export enum OfferCorrectionMailStatus {
  SENT = 'SENT',
  /** Nothing the contract mail shows was changed – saved without a mail. */
  NO_CHANGES = 'NO_CHANGES',
  /** Saved, but the mail to the customer failed. */
  FAILED = 'FAILED'
}
